import dialogsByPaymentCode from "@/config/dialogs";

function getDialog(code) {
  return dialogsByPaymentCode[code];
}

export default getDialog;
